import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Invoice, CreateInvoiceDto, UpdateInvoiceStatusDto, InvoiceStatus, VatConfig, UpdateVatConfigDto, PartnerLedger } from '../models/invoice.model';
import { apiBase } from './api-config';

@Injectable({ providedIn: 'root' })
export class InvoiceService {
  private http = inject(HttpClient);
  private base = `${apiBase}/invoices`;

  getAll(customerId?: number, status?: InvoiceStatus): Observable<Invoice[]> {
    let params = new HttpParams();
    if (customerId) params = params.set('customerId', customerId);
    if (status) params = params.set('status', status);
    return this.http.get<Invoice[]>(this.base, { params });
  }

  getById(id: number): Observable<Invoice> {
    return this.http.get<Invoice>(`${this.base}/${id}`);
  }

  create(dto: CreateInvoiceDto): Observable<Invoice> {
    return this.http.post<Invoice>(this.base, dto);
  }

  updateStatus(id: number, dto: UpdateInvoiceStatusDto): Observable<Invoice> {
    return this.http.put<Invoice>(`${this.base}/${id}/status`, dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }

  getVatConfig(): Observable<VatConfig> {
    return this.http.get<VatConfig>(`${this.base}/vat-config`);
  }

  upsertVatConfig(dto: UpdateVatConfigDto): Observable<VatConfig> {
    return this.http.put<VatConfig>(`${this.base}/vat-config`, dto);
  }

  getPartnerLedger(partnerId: number, from?: string, to?: string): Observable<PartnerLedger> {
    let params = new HttpParams();
    if (from) params = params.set('from', from);
    if (to) params = params.set('to', to);
    return this.http.get<PartnerLedger>(`${apiBase}/partners/${partnerId}/ledger`, { params });
  }
}
